
import { get, post } from "../common/dataFetch";
import { CountyDetail } from "../store/CountyLookUpStore";
 
export const getCountyDetail = (zipCode: string) => post<CountyDetail[]>(`CountyLookup/ReadByZipCode?zipCode=${zipCode}`, null);